<template>
  <div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="单号" prop="code">
        <el-input
            v-model="queryParams.code"
            placeholder="请输入单号"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="订单号" prop="dcode">
        <el-input
            v-model="queryParams.dcode"
            placeholder="请输入订单号"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="发出时间" prop="borrowddate">
        <el-date-picker clearable size="small"
                        v-model="queryParams.borrowddate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择发出时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="账号" prop="username">
        <el-input
            v-model="queryParams.username"
            placeholder="请输入账号"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-input v-model="queryParams.status" placeholder="请选择状态" clearable size="small">

          />
        </el-input>
      </el-form-item>
      <el-form-item label="发出地" prop="placeoforigin">
        <el-input
            v-model="queryParams.placeoforigin"
            placeholder="请输入发出地"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="目的地" prop="destination">
        <el-input
            v-model="queryParams.destination"
            placeholder="请输入目的地"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="件数" prop="inum">
        <el-input
            v-model="queryParams.inum"
            placeholder="请输入件数"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="数量" prop="iquantity">
        <el-input
            v-model="queryParams.iquantity"
            placeholder="请输入数量"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="客户地址" prop="addressee">
        <el-input
            v-model="queryParams.addressee"
            placeholder="请输入客户地址"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="客户电话" prop="tel">
        <el-input
            v-model="queryParams.tel"
            placeholder="请输入客户电话"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="预计到达时间" prop="yjddate">
        <el-date-picker clearable size="small"
                        v-model="queryParams.yjddate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择预计到达时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="memo">
        <el-input
            v-model="queryParams.memo"
            placeholder="请输入备注"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="录入时间" prop="ddatetime">
        <el-date-picker clearable size="small"
                        v-model="queryParams.ddatetime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择录入时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置{{ user.userName }}</el-button>
        <div>{{ user.userName }}</div>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            v-hasPermi="['wlsystem:logistics:add']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleUpdate"
            v-hasPermi="['wlsystem:logistics:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['wlsystem:logistics:remove']"
        >删除</el-button>



      </el-col>
      <el-col :span="1.5">
        <el-button
            type="warning"
            plain
            icon="el-icon-download"
            size="mini"
            :loading="exportLoading"
            @click="handleExport"
            v-hasPermi="['wlsystem:logistics:export']"
        >导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-upload
            class="upload-demo"
            action="/api/files/upload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="3"
            :on-exceed="handleExceed"
            :file-list="fileList"
        >
          <el-button size="mini" type="primary">导入.xlsx</el-button>
        </el-upload>
      </el-col>






      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="logisticsList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="自增字段" align="center" prop="id" />
      <el-table-column label="单号" align="center" prop="code" width="400" />
      <el-table-column label="订单号" align="center" prop="dcode" />
      <el-table-column label="发出时间" align="center" prop="borrowddate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.borrowddate, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号" align="center" prop="username" />
      <el-table-column label="类型" align="center" prop="doctype" />
      <el-table-column label="状态" align="center" prop="status" />
      <el-table-column label="发出地" align="center" prop="placeoforigin" />
      <el-table-column label="目的地" align="center" prop="destination" />
      <el-table-column label="件数" align="center" prop="inum" />
      <el-table-column label="数量" align="center" prop="iquantity" />
      <el-table-column label="客户地址" align="center" prop="addressee" />
      <el-table-column label="客户电话" align="center" prop="tel" />
      <el-table-column label="预计到达时间" align="center" prop="yjddate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.yjddate, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center" prop="memo" />
      <el-table-column label="录入时间" align="center" prop="ddatetime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.ddatetime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="录入时间" align="center" prop="cdefine1" />
      <el-table-column label="录入时间" align="center" prop="cdefine2" />
      <el-table-column label="录入时间" align="center" prop="cdefine3" />
      <el-table-column label="录入时间" align="center" prop="fhddate" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              v-hasPermi="['wlsystem:logistics:edit']"
          >修改</el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-hasPermi="['wlsystem:logistics:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
    />

    <!-- 添加或修改物流单号信息对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="单号" prop="code">
          <el-input v-model="form.code" placeholder="请输入单号" :disabled="true"/>
        </el-form-item>
        <el-form-item label="订单号" prop="dcode">
          <el-input v-model="form.dcode" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="发出时间" prop="borrowddate">
          <el-date-picker clearable size="small"
                          v-model="form.borrowddate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择发出时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="1">已发货</el-radio>
            <el-radio label="2">已收货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发出地" prop="placeoforigin">
          <el-input v-model="form.placeoforigin" placeholder="请输入发出地" />
        </el-form-item>
        <el-form-item label="目的地" prop="destination">
          <el-input v-model="form.destination" placeholder="请输入目的地" />
        </el-form-item>
        <el-form-item label="件数" prop="inum">
          <el-input v-model="form.inum" placeholder="请输入件数" />
        </el-form-item>
        <el-form-item label="数量" prop="iquantity">
          <el-input v-model="form.iquantity" placeholder="请输入数量" />
        </el-form-item>
        <el-form-item label="客户地址" prop="addressee">
          <el-input v-model="form.addressee" placeholder="请输入客户地址" />
        </el-form-item>
        <el-form-item label="客户电话" prop="tel">
          <el-input v-model="form.tel" placeholder="请输入客户电话" />
        </el-form-item>
        <el-form-item label="预计到达时间" prop="yjddate">
          <el-date-picker clearable size="small"
                          v-model="form.yjddate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择预计到达时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="memo">
          <el-input v-model="form.memo" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="录入时间" prop="ddatetime">
          <el-date-picker clearable size="small"
                          v-model="form.ddatetime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择录入时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "wlgz",
  data() {
    return {

      limitNum: 1,  // 上传excell时，同时允许上传的最大数
      fileList: [],   // excel文件列表
      //用户
      user: {},
      // 遮罩层
      loading: true,
      // 导出遮罩层
      exportLoading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 物流单号信息表格数据
      logisticsList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        code: null,
        dcode: null,
        borrowddate: null,
        username: null,
        doctype: null,
        status: null,
        placeoforigin: null,
        destination: null,
        inum: null,
        iquantity: null,
        addressee: null,
        tel: null,
        yjddate: null,
        memo: null,
        ddatetime: null,
        cdefine1: null,
        cdefine2: null,
        cdefine3: null,
        fhddate: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        ddatetime: [
          { required: true, message: "录入时间不能为空", trigger: "blur" }
        ],
      }
    };
  },
  mounted(){
    this.getUser();
  },
  created() {
    this.getList();

  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
          `The limit is 3, you selected ${
              files.length
          } files this time, add up to ${files.length + fileList.length} totally`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`)
    },

//获取用户
/*    getUser() {
      getUserProfile().then(response => {
        this.user = response.data;
      });
    },*/



    /** 查询物流单号信息列表 */
    getList() {
      this.loading = true;
    /*  listLogistics(this.queryParams).then(response => {
        this.logisticsList = response.rows;
        this.total = response.total;
        this.loading = false;
      });*/
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        code: null,
        dcode: null,
        borrowddate: null,
        username: null,
        doctype: null,
        status: "0",
        placeoforigin: null,
        destination: null,
        inum: null,
        iquantity: null,
        addressee: null,
        tel: null,
        yjddate: null,
        memo: null,
        ddatetime: null,
        cdefine1: null,
        cdefine2: null,
        cdefine3: null,
        fhddate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加物流单号信息";
    },
    /** 修改按钮操作 */
   /* handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getLogistics(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改物流单号信息";
      });
    },
    /!** 提交按钮 *!/
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateLogistics(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addLogistics(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /!** 删除按钮操作 *!/
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除物流单号信息编号为"' + ids + '"的数据项？').then(function() {
        return delLogistics(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /!** 导出按钮操作 *!/
    handleExport() {
      const queryParams = this.queryParams;
      this.$modal.confirm('是否确认导出所有物流单号信息数据项？').then(() => {
        this.exportLoading = true;
        return exportLogistics(queryParams);
      }).then(response => {
        this.$download.name(response.msg);
        this.exportLoading = false;
      }).catch(() => {});
    }*/
  },
}
</script>

<style >

</style>
